module.exports = __webpack_public_path__ + "img/shift-validation-success.a8cf5934.png";